import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import ja from './ja.json';
import zhTW from './zh-TW.json';

export const SUPPORTED_LANGS = ['en', 'zh-TW', 'ja'] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

/** True when built or served with `--mode staging` (npm run dev:staging, build:staging). */
export const IS_STAGING = import.meta.env.MODE === 'staging';

export const LANG_LABELS: Record<SupportedLang, string> = {
  en: 'EN',
  'zh-TW': '繁中',
  ja: '日本語',
};

export const LANG_FONTS: Record<SupportedLang, string> = {
  en: "'Noto Sans', 'Noto Sans TC', 'Noto Sans JP', sans-serif",
  'zh-TW': "'Noto Sans', 'Noto Sans TC', 'Noto Sans JP', sans-serif",
  ja: "'Noto Sans', 'Noto Sans JP', 'Noto Sans TC', sans-serif",
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      'zh-TW': { translation: zhTW },
      ja: { translation: ja },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGS as unknown as string[],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'helloant.lang',
    },
  });

export default i18n;
